import * as Yup from "yup";

Yup.setLocale({
  object: {
    shape: "shape",
  },
  mixed: {
    required: "required",
  },
  string: {
    required: "required",
    nullable: "nullable",
    matches: "matches",
    email: "email",
    min: ({ min }) => ({ key: "min.string", values: { min } }),
    max: ({ max }) => ({ key: "max.string", values: { max } }),
  },
  number: {
    required: "required",
    nullable: "nullable",
    min: ({ min }) => ({ key: "min.number", values: { min } }),
    max: ({ max }) => ({ key: "max.number", values: { max } }),
  },
  array: {
    required: "required",
    nullable: "nullable",
    min: ({ min }) => ({ key: "min.array", values: { min } }),
    max: ({ max }) => ({ key: "max.array", values: { max } }),
    length: ({ length }) => ({ key: "length.array", values: { length } }),
  },
});

export const globalValidations = {
  string: Yup.string(),
  requiredString: Yup.string().required(),
  requiredString_minmax: Yup.string().required().min(3).max(190),
  requiredString_nullable: Yup.string().required().nullable(),
  requiredNumber: Yup.number()
    .typeError("nullable")
    .integer()
    .min(0)
    .required(),
  phoneValidator: Yup.string()
    .required()
    .min(9, { key: "phone_length", values: { num: 9 } })
    .max(9, { key: "phone_length", values: { num: 9 } })
    .matches(/^5\d{8}$/, "invaled_phone"),

  birthDate: Yup.string()
    .required()
    .test("invalid-date", "age_min", (value) => {
      const birthDate = new Date(value);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();
      return (
        age > 18 ||
        (age === 18 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))
      );
    })
    .test("invalid-date", "age_max", (value) => {
      const birthDate = new Date(value);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();

      return (
        age < 120 ||
        (age === 120 && (monthDiff < 0 || (monthDiff === 0 && dayDiff <= 0)))
      );
    }),
  emailValidator: Yup.string()
    .required()
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "invalid_email"
    ),
  nidValidator: Yup.string()
    .required()
    .min(10, { key: "nin_length", values: { num: 10 } })
    .max(10, { key: "nin_length", values: { num: 10 } })
    .matches(/^[12][0-9]{9}$/, "nid"),
  passwordValidator: Yup.string()
    .required()
    .min(8, "password.min")
    .matches(/[A-Z]/, "password.uppercase")
    .matches(/[a-z]/, "password.lowercase")
    .matches(/\d/, "password.number")
    .matches(/[$%#*&@]/, "password.symbol")
    .matches(/^\S*$/, "password.space"),
  confirmPasswordValidator: Yup.string()
    .required()
    .test("passwords-match", "password.match", function (value) {
      return !value || value === this.parent.password;
    }),
  crn: Yup.string()
    .required()
    .test(
      "starts-with-7",
      "cn_start",
      (value) => value && value.startsWith("7")
    )
    .test("length-10", "cn_length", (value) => value && value.length === 10)
    .matches(/^\d+$/, "cn_type")
    .matches(/^7\d{9}$/, "invaled_cn"),
  filesValidator: Yup.array().max(3),
};

export default Yup;
